import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML, encodeHTML } from "@utils/CommonUtils";
import { Tabs } from "antd";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { useHasAccess } from "~/Hooks/useHasAccess";
import { post, put } from "~/Services";
import { magpHost } from "~/Utils";
import { useCalendarLegends } from "../Others.hook";
import { fields } from "../constants";

export const CalendarLegends = () => {
  const navigate = useNavigate();
  const query = useQuery();
  const { openToast } = useNotification();
  const { hasRole } = useHasAccess();

  const {
    data: welcomePageForCalendarData,
    error,
    isLoading,
    isError,
    refetch: refetchData,
  } = useCalendarLegends();

  const id = query?.get("id");
  const {
    data: welcomePageForCalendarById,
    isLoading: isLoadingwelcomePageForCalendar,
    refetch: refetchDataById,
  } = useDocumentDetails(id || "");

  useEffect(() => {
    refetchData();
  }, [refetchData]);

  useEffect(() => {
    if (id) {
      refetchDataById();
    }
  }, [id, refetchDataById]);

  useEffect(() => {
    if (!query.get("activeTab")) {
      navigate(`/dedicated/magp/others?activeTab=welcomePageForCalendar`, {
        replace: true,
      });
    }
  }, [navigate, query]);

  const welcomePageForCalendarConfig: FormConfig = {
    initialValues: {
      name: welcomePageForCalendarById?.payload
        ? decodeHTML(welcomePageForCalendarById?.payload?.name)
        : decodeHTML(welcomePageForCalendarData?.[0]?.name),
      field_start_day_ms: welcomePageForCalendarById?.payload
        ? decodeHTML(welcomePageForCalendarById?.payload?.field_start_day_ms)
        : decodeHTML(welcomePageForCalendarData?.[0]?.field_start_day_ms),
      field_start_day_zh: welcomePageForCalendarById?.payload
        ? decodeHTML(welcomePageForCalendarById?.payload?.field_start_day_zh)
        : decodeHTML(welcomePageForCalendarData?.[0]?.field_start_day_zh),
      field_start_day_color_code: welcomePageForCalendarById?.payload
        ? decodeHTML(welcomePageForCalendarById?.payload?.field_start_day_color_code)
        : decodeHTML(welcomePageForCalendarData?.[0]?.field_start_day_color_code),
      field_current_day_en: welcomePageForCalendarById?.payload
        ? decodeHTML(welcomePageForCalendarById?.payload?.field_current_day_en)
        : decodeHTML(welcomePageForCalendarData?.[0]?.field_current_day_en),
      field_current_day_ms: welcomePageForCalendarById?.payload
        ? decodeHTML(welcomePageForCalendarById?.payload?.field_current_day_ms)
        : decodeHTML(welcomePageForCalendarData?.[0]?.field_current_day_ms),
      field_current_day_zh: welcomePageForCalendarById?.payload
        ? decodeHTML(welcomePageForCalendarById?.payload?.field_current_day_zh)
        : decodeHTML(welcomePageForCalendarData?.[0]?.field_current_day_zh),
      field_current_day_color_code: welcomePageForCalendarById?.payload
        ? decodeHTML(welcomePageForCalendarById?.payload?.field_current_day_color_code)
        : decodeHTML(welcomePageForCalendarData?.[0]?.field_current_day_color_code),
      field_exp_date_en: welcomePageForCalendarById?.payload
        ? decodeHTML(welcomePageForCalendarById?.payload?.field_exp_date_en)
        : decodeHTML(welcomePageForCalendarData?.[0]?.field_exp_date_en),
      field_exp_date_ms: welcomePageForCalendarById?.payload
        ? decodeHTML(welcomePageForCalendarById?.payload?.field_exp_date_ms)
        : decodeHTML(welcomePageForCalendarData?.[0]?.field_exp_date_ms),
      field_exp_date_zh: welcomePageForCalendarById?.payload
        ? decodeHTML(welcomePageForCalendarById?.payload?.field_exp_date_zh)
        : decodeHTML(welcomePageForCalendarData?.[0]?.field_exp_date_zh),
      field_exp_day_color_code: welcomePageForCalendarById?.payload
        ? decodeHTML(welcomePageForCalendarById?.payload?.field_exp_day_color_code)
        : decodeHTML(welcomePageForCalendarData?.[0]?.field_exp_day_color_code),
      field_multi_en: welcomePageForCalendarById?.payload
        ? decodeHTML(welcomePageForCalendarById?.payload?.field_multi_en)
        : decodeHTML(welcomePageForCalendarData?.[0]?.field_multi_en),
      field_multi_ms: welcomePageForCalendarById?.payload
        ? decodeHTML(welcomePageForCalendarById?.payload?.field_multi_ms)
        : decodeHTML(welcomePageForCalendarData?.[0]?.field_multi_ms),
      field_multi_zh: welcomePageForCalendarById?.payload
        ? decodeHTML(welcomePageForCalendarById?.payload?.field_multi_zh)
        : decodeHTML(welcomePageForCalendarData?.[0]?.field_multi_zh),
      field_multi_contract_code: welcomePageForCalendarById?.payload
        ? decodeHTML(welcomePageForCalendarById?.payload?.field_multi_contract_code)
        : decodeHTML(welcomePageForCalendarData?.[0]?.field_multi_contract_code),
    },
    fields: fields.calendarLegends,
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    // let excludedKeys: any = [];
    // for (let key in data) {
    //   if (typeof data[key] === "string" && !excludedKeys.includes(key)) {
    //     data[key] = encodeHTML(data[key]);
    //   }
    // }
    const payload = {
      action: action,
      method: method,
      module: "OTHERS",
      subModule: query?.get("activeTab"),
      type: "DEDICATED",
      application: "MAGP",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "MAGP",
          apiUrl: apiUrl,
        },
      ],
      payload: {
        ...data,
        created_at: "2024-04-09T01:03:09",
        updated_at: "2024-04-09T01:03:09",
        published: true,
      },
      status: status,
    };
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response:any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === 'OK' && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else{
            navigate("/dedicated/status-information?activeTab=draft");
          }
          refetchDataById();
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response:any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === 'OK' && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else{
            navigate("/dedicated/status-information?activeTab=draft");
          }
          refetchDataById();
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <DynamicForm
      isLoading={isLoading || isLoadingwelcomePageForCalendar}
      config={welcomePageForCalendarConfig}
      onSubmit={(data, buttonValue, reviewNotes) =>
        onSubmit(
          data,
          `${magpHost}/api/color-code-view-update-api/224`,
          "UPDATE",
          "PATCH",
          buttonValue == "save" ? "DRAFT" : "PENDING",
          reviewNotes
        )
      }
    />
  );
};
